import {
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { RoundPipe } from '../../../pipes/round.pipe';
import { User } from '../../../models/User';
import {
  Breakpoint,
  MediaQueryService
} from '../../../services/media-query.service';
import { Observable, Subscription } from 'rxjs';
import { MobileAppRanking } from '../rankings/models/mobileAppRanking';
import { SideNavItem } from '../rankings/models/sideNavItem';
import { SideNavItemsMap } from '../rankings/models/sideNavItemsMap';
import { SIDENAV_ITEMS } from './SIDENAV_ITEMS';
import { SIDENAV_ITEMSMAPS } from './SIDENAV_ITEMSMAPS';
import { REPORT_CONFIG, ReportConfig } from './REPORT_CONFIG';
import { SIDENAV_ITEMS_RISK_CATEGORIES } from './SIDENAV_ITEMS_RISK_CATEGORIES';
import { FAQ_CONFIG, FaqItem } from './FAQ_CONFIG';
import { HighRiskRegistryService } from 'app/services/high-risk-registry.service';
import { AppNavigationService } from 'app/services/app-navigation.service';
import { TrackingService } from 'app/services/tracking.service';
import { AuthService } from 'app/services/auth.service';
import { RankingsAnonFormService } from 'app/services/rankings-anon-form.service';

declare let jQuery: any;

@Component({
  selector: 'app-high-risk-registry',
  templateUrl: './high-risk-registry.component.html',
  styleUrls: ['./high-risk-registry.component.scss']
})
export class HighRiskRegistryComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  currentConfig: ReportConfig;
  loading: boolean;
  loadingData: boolean;
  gridData: Array<MobileAppRanking>;
  showLoadMore: boolean;
  showLoadingMore: boolean;
  showContactSales: boolean;
  noResult = false;
  sideNavItems: Array<SideNavItem>;
  downloading: boolean;
  currentMapId: string;
  sideNavItemsMaps: Array<SideNavItemsMap>;
  selectedCategory: string;

  lastUpdatedMonthLabel: Date;
  start: number;
  currentSideNavItem: SideNavItem;
  desktop$: Observable<boolean>;
  isDestroyed: boolean;

  showFreemiumForm = false;
  showAnonEmailUnlockForm = false;

  osOptions = [];
  selectedOs = '';
  selectedGroup = '';
  rowLimit = 6;
  fadeStart = 3;

  faqItemsLeft: FaqItem[] = FAQ_CONFIG.slice(0, 2);
  faqItemsRight: FaqItem[] = FAQ_CONFIG.slice(2);

  basePath: string = '/ad-fraud-watch-list';
  routerSub!: Subscription;

  @ViewChild('sideNav') sideNav: ElementRef;

  get isAnonymous(): boolean {
    return this._userService.isAnonymous();
  }

  get isFreemium(): boolean {
    return this._userService.isFreemium();
  }

  get isEnterprise(): boolean {
    return this._userService.isEnterprise();
  }

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _appNavService: AppNavigationService,
    private _authService: AuthService,
    private _rankingsAnonFormService: RankingsAnonFormService,
    private _mediaQueryService: MediaQueryService,
    private _rankingsService: HighRiskRegistryService,
    private _tracking: TrackingService,
    public _userService: User
  ) {
    this.loading = false;
    this.loadingData = false;
    this.showLoadingMore = false;
    this.showLoadMore = true;
    this.showContactSales = false;
  }

  ngOnInit(): void {
    this.desktop$ = this._mediaQueryService.gt(Breakpoint.md);
    this.isDestroyed = false;
    this.loadLastUpdatedDate();

    // Detect base path from current URL
    const currentUrl = this._router.url;
    if (currentUrl.includes('/ad-fraud-ioc-db')) {
      this.basePath = '/ad-fraud-ioc-db';
    } else {
      this.basePath = '/ad-fraud-watch-list';
    }

    this.sideNavItems = JSON.parse(JSON.stringify(SIDENAV_ITEMS));
    this.sideNavItemsMaps = JSON.parse(JSON.stringify(SIDENAV_ITEMSMAPS));
    this.sideNavItemsMaps
      .map(map => map.sideNavItems)
      .forEach(sideNavItems => {
        sideNavItems.forEach(sideNavItem => (sideNavItem.active = false));
      });

    this.routerSub = this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.initCategory();
      }
    });

    this.initCategory();

    this._appNavService.setHideAppBar(true);

    this._tracking.pageTrack();

    this.toggleTableBlur();
  }

  initCategory() {
    const category = this._route.snapshot.params['category'];
    if (category) {
      let sideNavItems = [];
      this.sideNavItemsMaps.forEach(map => {
        sideNavItems = sideNavItems.concat(map.sideNavItems);
      });
      const sideNavItem =
        sideNavItems.filter(item => item.id === category)[0] ||
        this.sideNavItemsMaps[0].sideNavItems[0];
      this.sideNavItemClick(sideNavItem);
      this.selectedCategory = sideNavItem.id;
    }
  }

  ngAfterViewInit() {
    // console.log( this.sideNav.nativeElement );
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
    this._appNavService.setHideAppBar(false);
    this.isDestroyed = true;
  }

  initOsOptions() {
    let osOptions = [];
    if (this.currentConfig.osFilterOptions) {
      osOptions = JSON.parse(
        JSON.stringify(this.currentConfig.osFilterOptions)
      );
      this.selectedGroup = this.currentConfig.selectedGroup;
    }

    this.osOptions = osOptions;
    this.selectedOs = osOptions[0]?.value;
  }

  initLoadingData() {
    this.loading = true;
    this.loadingData = true;
    this.gridData = [];
    this.showLoadMore = true;
    this.showFreemiumForm = false;
    this.start = 0;
    this.loadGridData();
  }

  sideNavItemClick(sideNavItem: SideNavItem) {
    if (!this.loading && !this.loadingData && !sideNavItem.active) {
      const foundConfig = REPORT_CONFIG.filter(
        config => config.key === sideNavItem.id
      )[0];
      if (foundConfig) {
        this.currentSideNavItem = sideNavItem;
        this.currentMapId = sideNavItem.mapId;
        this.currentConfig = foundConfig;

        this.initOsOptions();
        this.initLoadingData();

        const sideNavItems = SIDENAV_ITEMS.concat(
          SIDENAV_ITEMS_RISK_CATEGORIES
        );
        sideNavItems.forEach(navItem => {
          navItem.active = sideNavItem.id === navItem.id;
        });
      }
    }

    setTimeout(() => {
      // jQuery(document).scrollTop(0);
    }, 500);

    this._rankingsService.setPageDocumentMeta(this.currentConfig);
  }

  onItemClick(rowIdx, dataItem) {
    this.trackTableRowClicked(rowIdx, dataItem);
    window.open(
      'https://www.pixalate.com/products/blocking?hsCtaTracking=357072ac-9278-4250-857f-79a31bedb633%7C571e2434-d4d5-40e5-9238-6ff8dab0f10a',
      '_blank'
    );
  }

  loadMore() {
    if (this.isAnonymous) {
      this._authService.login();
    } else if (this.isFreemium) {
      this.showFreemiumForm = true;
    } else {
      this.showLoadingMore = true;
      this.loadGridData(true);
    }

    this.showLoadMore = false;
  }

  loadGridData(logLoadMore = false) {
    this.loadingData = true;
    this.rowLimit = this.isEnterprise ? 50 : this.currentConfig.rowLimit || 6;
    this.fadeStart = this.currentConfig.fadeStart || 3;

    const addParams = new Map();

    if (this.currentConfig.osFilterOptions) {
      addParams.set('os', this.selectedOs);
    } else if (
      this.currentConfig.key == 'fraudulent-ctv-bundles' &&
      this.isAnonymous
    ) {
      addParams.set('os', 'roku');
    }

    // this._rankingsService.setPageDocumentMeta(this.currentConfig);

    const additionalQueryString =
      this._rankingsService.mapToUrlParam(addParams);
    const limit = 25;

    const routeParams = [this.basePath, this.currentSideNavItem.id];

    const reportId = this.currentConfig.reportId;
    void this._rankingsService
      .getRankingsData(reportId, this.start, limit, additionalQueryString)
      .then(response => {
        if (response && response['docs']) {
          this.gridData =
            this.start === 0
              ? response['docs']
              : this.gridData.concat(response['docs']);
          this.showLoadingMore = false;

          const dataCount = this.gridData.length;
          this.start = dataCount;
          this.noResult = dataCount === 0;

          if (this.isEnterprise) {
            const totalRow = response['numFound'];
            const maxRow = Math.min(totalRow, 50);
            this.showLoadMore = totalRow > dataCount && dataCount < maxRow;
            this.showContactSales = !this.showLoadMore;
          }

          if (logLoadMore) {
            this._tracking.eventTrack('adfraud_load_more', {
              items_loaded: dataCount
            });
          } else {
            this._tracking.eventTrack('adfraud_page_load', {
              url: window.location.href
            });
          }
        }
        setTimeout(() => {
          this.loading = false;
          this.loadingData = false;

          if (!this.isDestroyed) {
            void this._router.navigate(routeParams, {
              relativeTo: this._route,
              queryParams: this._route.snapshot.queryParams,
              queryParamsHandling: 'merge'
            });
          }
        }, 300);
      });
  }

  loadLastUpdatedDate() {
    void this._rankingsService.getLastUpdated().then(response => {
      if (response && response['docs']) {
        const lastUpdatedDate = response['docs'][0]['lastUpdatedDate'];
        if (lastUpdatedDate) {
          const arrDate = lastUpdatedDate.split('-');
          this.lastUpdatedMonthLabel = new Date(
            arrDate[2],
            arrDate[1] - 1,
            arrDate[0]
          );
        }
      }
    });
  }

  scheduleDemo(position: string) {
    this._tracking.eventTrack('adfraud_contact_sales', {
      position
    });
    window.open('https://info.pixalate.com/scheduledemo', '_blank');
  }

  openBlockPage() {
    window.open('https://www.pixalate.com/products/blocking', '_blank');
  }

  changeOs(os: string) {
    this._tracking.eventTrack('adfraud_platform_change', {
      platform: os
    });

    this.selectedOs = os;
    this.initLoadingData();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (
      jQuery('.rankings-main-content .right-content') &&
      jQuery('.rankings-main-content .right-content').offset() &&
      jQuery('.right-content.rankings .grid-data') &&
      jQuery('.right-content.rankings .grid-data').offset()
    ) {
      const offsetTop = jQuery('.rankings-main-content .right-content').offset()
        .top;
      const scrollTop = jQuery(window).scrollTop();
      if (scrollTop < offsetTop) {
        jQuery('.rankings-main-content').removeClass('sticky-nav');
      } else {
        jQuery('.rankings-main-content').addClass('sticky-nav');
      }

      const mobilediff =
        jQuery(window).height() +
        (jQuery(window).scrollTop() -
          (jQuery('.rankings-main-content .right-content').offset().top +
            jQuery('.rankings-main-content .right-content').outerHeight()));
      if (mobilediff > 0) {
        jQuery('.rankings-main-content .side-navigation').css(
          'margin-bottom',
          mobilediff + 'px'
        );
      } else {
        jQuery('.rankings-main-content .side-navigation').css(
          'margin-bottom',
          '0px'
        );
      }

      const iscrollTop = jQuery(document).scrollTop();
      const ioffsetTop = jQuery('.right-content.rankings .grid-data').offset()
        .top;
      const iheaderHeight = jQuery(
        '.right-content.rankings .grid-header'
      ).outerHeight();

      if (iscrollTop >= ioffsetTop - iheaderHeight) {
        jQuery('.right-content.rankings').addClass('sticky');
      } else {
        jQuery('.right-content.rankings').removeClass('sticky');
      }
    }
  }

  trackTableRowClicked(idx, data) {
    this._tracking.eventTrack('adfraud_row_clicked', {
      row_index: idx + 1,
      row_data: data
    });
  }

  toggleTableBlur() {
    var hasSubmittedAnonEmail = this._rankingsAnonFormService.isFormSubmitted();
    this.showAnonEmailUnlockForm = this.isAnonymous && !hasSubmittedAnonEmail;
  }
}
